import { Network } from 'lucide-react';
import type React from 'react';

import { classNames } from '@/lib/utils';

import { useCdcStore } from '../stores/useCdcStore';
import { useGraphExplorerStore } from '../stores/useGraphExplorerStore';

/**
 * CDC Graph Explorer toolbar button (top-right).
 * Visible only when a CDC vessel is selected.
 */
export const CdcGraphExplorerButton: React.FC = () => {
  const selectedMmsi = useCdcStore((state) => state.selectedMmsi);
  const openGraphExplorer = useGraphExplorerStore((state) => state.open);

  if (!selectedMmsi) return null;

  return (
    <div className="absolute top-2 right-[172px] z-[2] flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl border border-panel-border bg-panel-surface backdrop-blur-xl transition-all duration-250">
      <button
        aria-label="Explore Vessel Network"
        className={classNames(
          'relative flex h-full w-full items-center justify-center bg-transparent text-white shadow-none transition-all duration-300',
          'hover:bg-white/10 hover:backdrop-blur-sm hover:shadow-sidebar-hover active:bg-white/15',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40',
          'rounded-lg',
        )}
        onClick={() => openGraphExplorer(selectedMmsi, selectedMmsi)}
        title="Explore Vessel Network"
        type="button"
      >
        <Network className="h-6 w-6" />
      </button>
    </div>
  );
};
